module.exports = __webpack_public_path__ + "static/img/kongtiao-zhire.2fe5ee85.png";